import axios from "axios";
import { BASEURL, CRED } from "../constant/constant";

const setUpAxios = () => {
  axios.defaults.baseURL = BASEURL;
  axios.defaults.headers.common["Authorization"] = localStorage.getItem(CRED);
};

export default setUpAxios;
